var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarGreenNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#28C76F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8337 8.49998H20.167V7.66665C20.167 7.16665 19.8337 6.83331 19.3337 6.83331C18.8337 6.83331 18.5003 7.16665 18.5003 7.66665V8.49998H13.5003V7.66665C13.5003 7.16665 13.167 6.83331 12.667 6.83331C12.167 6.83331 11.8337 7.16665 11.8337 7.66665V8.49998H10.167C8.75033 8.49998 7.66699 9.58331 7.66699 11V22.6666C7.66699 24.0833 8.75033 25.1666 10.167 25.1666H21.8337C23.2503 25.1666 24.3337 24.0833 24.3337 22.6666V11C24.3337 9.58331 23.2503 8.49998 21.8337 8.49998ZM10.167 10.1666H11.8337V11C11.8337 11.5 12.167 11.8333 12.667 11.8333C13.167 11.8333 13.5003 11.5 13.5003 11V10.1666H18.5003V11C18.5003 11.5 18.8337 11.8333 19.3337 11.8333C19.8337 11.8333 20.167 11.5 20.167 11V10.1666H21.8337C22.3337 10.1666 22.667 10.5 22.667 11V13.5H9.33366V11C9.33366 10.5 9.66699 10.1666 10.167 10.1666ZM10.167 23.5H21.8337C22.3337 23.5 22.667 23.1666 22.667 22.6666V15.1666H9.33366V22.6666C9.33366 23.1666 9.66699 23.5 10.167 23.5Z",
    fill: "#28C76F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreenNotification);
export default __webpack_public_path__ + "static/media/calendar-green-notification.1a0e4ef38cf73469ebcbbd8c3d78c78a.svg";
export { ForwardRef as ReactComponent };